// Main exports
// These files get exposed to the window under the `sma` namespace
// Modules should only be required here if they are to be used from the window scope

module.exports = {
	ajax: require('sma.common/ajax'),

	// render react component
	renderRC: require('sma.admin/components/react/render').default,

	amplitude: require('sma.common/components/amplitude'),

	Connect: require('sma.common/Connect.jsx'),

	components: {
		NavDropdown: require('sma.admin/components/dropdown').Dropdown,
		List: require('sma.admin/components/list'),
		Grid: require('sma.admin/components/grid'),

		CookieBanner: require('sma.common/components/cookie_banner'),

		ImageCropper: require('sma.common/components/image_uploader').ImageCropper,

		ConditionSelect: require('sma.admin/components/conditionselect').ConditionSelect,
		ConditionSelectFilters: require('sma.admin/components/conditionselectfilters').ConditionSelectFilters,

		Forms: require('sma.admin/components/forms'),
		Alert: require('sma.admin/components/alert'),
		DropSelect: require('sma.admin/components/dropdowns/dropselect'),
		DropSelectorDrilldown: require('sma.admin/components/dropdowns/dropselectordrilldown'),
		DropSelector: require('sma.admin/components/dropdowns/dropselector'),
		DropSelectDrilldown: require('sma.admin/components/dropdowns/dropselectdrilldown'),
		MultiSelect: require('sma.admin/components/dropdowns/multiselect'),
		MultiSelectEditable: require('sma.admin/components/dropdowns/multiselecteditable'),
		Filter: require('sma.admin/components/filters/filters'),
		Loader: require('sma.admin/components/loader'),
		Dropdown: require('sma.admin/components/dropdowns/dropdown'),
		JumpToDropdown: require('sma.admin/components/dropdowns/jump_dropdown'),

		Rely: require('sma.admin/components/rely'),
	},

};
